module.exports = __webpack_public_path__ + "img/badge.09f55540.png";